import commonHttp from "./commonHttp";

/**
 * 校验二维码是否过期
 * @param params 请求的参数
 * @param params.identificationCode 二维码唯一标识 - identificationCode属性
 */
export function fetchFarmQrCodeToVerify(params) {
  return commonHttp.get(`/qrCode/farmQrCodeToVerify?identificationCode=${params.identificationCode}`);
}

/**
 * 溯源码可使用次数减一
 * @param params 请求的参数
 * @param params.identificationCode 二维码唯一标识 - identificationCode属性
 */
// export function fetchFarmQrCodeCountToSubtraction(params) {
//   return commonHttp.get(`/qrCode/farmQrCodeCountToSubtraction?identificationCode=${params.identificationCode}`);
// }

/**
 * 获取溯源码详情信息
 * @param params 请求的参数
 * @param params.identificationCode 二维码唯一标识 - identificationCode属性
 */
export function fetchFarmQrCodeById(params) {
  return commonHttp.get(`/qrCode/farmQrCodeById?identificationCode=${params.identificationCode}`);
}

/**
 * 获取园区信息详情
 * @param params 请求的参数
 * @param params.id 园区🆔
 */
export function fetchGardenInfo(params) {
  return commonHttp.get(`/qrCode/gardenInfo?id=${params.id}`);
}

/**
 * 获取作物信息详情
 * @param params 请求的参数
 * @param params.id 种植🆔
 */
export function fetchSelectZdFarmTraceabilityByIdToH5(params) {
  return commonHttp.get(`/qrCode/selectZdFarmTraceabilityByIdToH5?id=${params.id}`);
}

/**
 * 获取视频信息详情
 * @param params 请求的参数
 * @param params.id 视频🆔
 */
export function fetchFarmGifsById(params) {
  return commonHttp.get(`/qrCode/farmGifsById?id=${params.id}`);
}

/**
 * 获取农事信息详情
 * @param params 请求的参数
 * @param params.plantId 种植🆔
 */
export function fetchFarmPlanList(params) {
  return commonHttp.get(`/qrCode/farmPlanList?plantId=${params.plantId}`);
}

/**
 * 获取报告信息详情
 * @param params 请求的参数
 * @param params.id 报告🆔
 */
export function fetchZdFarmReportById(params) {
  return commonHttp.get(`/qrCode/zdFarmReportById?id=${params.id}`);
}

/**
 * 获取采摘信息详情
 * @param params 请求的参数
 * @param params.id 采摘🆔
 */
export function fetchFarmPickById(params) {
  return commonHttp.get(`/qrCode/farmPickById?id=${params.id}`);
}

/**
 * 根据种植id获取已绑定的二级设备信息
 * @param params 请求的参数
 * @param params.plantId 种植🆔
 */
export function fetchGetEquipmentSecondByIds(params) {
  return commonHttp.get(`/qrCode/getEquipmentSecondByIds?plantId=${params.plantId}`);
}

/**
 * 根据种植id和采摘id 获取平均值 最大值 最小值
 * @param params 请求的参数
 * @param params.plantId 种植🆔
 * @param params.pickId 采摘🆔
 */
export function fetchGetDataByIds(params) {
  return commonHttp.get(`/qrCode/getDataByIds?plantId=${params.plantId}&pickId=${params.pickId}`);
}

/**
 * 根据设备id 获取每天平均值
 * @param params 请求的参数
 * @param params.zdEquipmentSecondId 设备🆔
 * @param params.plantId 种植🆔
 * @param params.pickId 采摘🆔
 */
export function fetchZdDataByIdEquipmentSecondById(params) {
  return commonHttp.get(`/qrCode/getDataById?zdEquipmentSecondId=${params.zdEquipmentSecondId}&plantId=${params.plantId}&pickId=${params.pickId}`);
}

const api = {
  fetchFarmQrCodeToVerify,
  // fetchFarmQrCodeCountToSubtraction,
  fetchFarmQrCodeById,
  fetchGardenInfo,
  fetchSelectZdFarmTraceabilityByIdToH5,
  fetchFarmGifsById,
  fetchFarmPlanList,
  fetchZdFarmReportById,
  fetchFarmPickById,
  fetchGetEquipmentSecondByIds,
  fetchGetDataByIds,
  fetchZdDataByIdEquipmentSecondById,
};

export default api;
